import { ROOT_CATALOG_URL } from '@/shared/constants/urlConstants';
import { extractList } from '@/shared/utils/unwrapApiResponse';
import { logError, normalizeError } from '@/shared/lib/errors';
import { useGeoLocation } from '@/entities/geo/model/useGeoLocation';
import type { ILawyerCardInfo } from '@/entities/lawyer/model/types/lawyer';

export const useTopSpecialists = () => {
  const { $lawyerService } = useNuxtApp();
  const isMobile: boolean = useIsMobile();

  const link = ROOT_CATALOG_URL;

  const { getGeoSlug } = useGeoLocation();

  const { data: lawyers } = useAsyncData<ILawyerCardInfo[]>(
    () => 'top-specialists',
    async () => {
      try {
        const city = await getGeoSlug();

        const dataReq = {
          city,
          metro: null,
          district: null,
          category: null,
          subcategory: null,
          is_lawyer: null,
          is_advocate: null,
          is_lawyer_company: null,
          is_advocate_company: null,
          rating: 4,
          experience: null,
          appointment_types: [],
          cost: null,
        };

        return extractList<ILawyerCardInfo>(
          await $lawyerService.getLawyers(dataReq, {
            page: 1,
            per_page: 5,
            sort: 'rating',
          }),
        );
      } catch (error) {
        logError(normalizeError(error), { action: 'top-specialists' });
        return [];
      }
    },
    { default: () => [] },
  );

  const dotsCount: ComputedRef<number> = computed(() => {
    const count = lawyers.value?.length ?? 0;
    const snaps = isMobile ? count : Math.ceil(count / 2);
    return snaps > 1 ? snaps : 0;
  });

  return { lawyers, link, dotsCount };
};

export default useTopSpecialists;
